const techStack = [
  { name: "React js", link: "https://reactjs.org/" },
  {
    name: "React Router",
    link: "https://reactrouter.com/web/guides/quick-start",
  },
  {
    name: "React Query",
    link: "https://react-query.tanstack.com/",
  },
  { name: "Primer Design System React", link: "https://primer.style/react/" },
  {
    name: "Github Trending API",
    link: "https://gh-trending-api.herokuapp.com/redoc",
  },
  {
    name: "Icons",
    link: "https://primer.style/octicons/",
  },
];

export default techStack;
